import client from './main-client';

export const getDealRevenueApi = (params) => client().get('/deal-pipeline-revenue', { params });
export const updateDealRevenueApi = (params) => client()
  .patch(`/deal-pipeline-revenue/${params.id}?isCustomFundingDate=${params.isCustomFundingDate}`,
    params);
export const addDealRevenueApi = (data) => client().post('/deal-pipeline-revenue', data);
